import React, {useState, useEffect} from 'react'
import clsx from 'clsx'
import {Typography} from '../components/Typography'
import {Icon, Button} from '../components/Button'
import {HeroBanner} from '../components/HeroBanner'
import {Tag} from '../components/Tag'
import {ImgFilters} from '../components/ImgFilters'
import {Card} from '../components/Card'
import {Depositions} from '../components/Depoimentos'
import plataformaImage from '../img/plataforma.png'
import posImage from '../img/pos.png'
import eadImage from '../img/ead-01.jpg'
import alunos from '../img/icons/alunos.svg'
import certificado from '../img/icons/certificado.svg'
import filtro from '../img/icons/filtro.svg'
import professores from '../img/icons/professores.svg'
import raciocinio from '../img/icons/raciocinio.svg'
import {useConfigQuery} from '../utils/hooks/useConfigQuery'
import {useProfessorsQuery} from '../utils/hooks/useProfessorsQuery'

const Title = ({children}) => {
  return (
    <div className="flex items-center justify-center">
      <span className="block w-8 h-1 bg-gray-100 rounded opacity-50" />
      <Typography variant="heading2" className="px-3" color="gray-900">
        {children}
      </Typography>
      <span className="block w-8 h-1 bg-gray-100 rounded opacity-50" />
    </div>
  )
}

const FisioSection = () => {
  const {studantCount} = useConfigQuery()
  return (
    <div className="mx-auto max-w-screen-xl">
      <div className="py-10 space-y-8">
        <Title>FISIOemORTOPEDIA</Title>

        <div className="lg:grid lg:grid-cols-3 lg:gap-4">
          <div className="flex px-4 pb-8 lg:items-start">
            <div className="flex items-center justify-center h-20 mr-6">
              <Icon icon={alunos} />
            </div>
            <Typography as="div">
              <Typography variant="heading" as="p" color="blue-500" uppercase>
                {studantCount}
              </Typography>
              <Typography size="lg">Alunos em todo Brasil</Typography>
            </Typography>
          </div>

          <div className="lg:col-span-2 lg:grid lg:grid-cols-2 lg:gap-4 space-y-8 lg:space-y-0">
            <div className="flex flex-col px-4 lg:flex-row space-y-4 lg:space-y-0">
              <div className="flex-none h-16 lg:w-24">
                <Icon icon={professores} />
              </div>
              <Typography as="div" align="center" className="lg:text-left">
                <Typography color="blue-500" weight="black" as="span" uppercase>
                  Professores renomados
                </Typography>{' '}
                que são{' '}
                <Typography color="blue-500" weight="black" as="span" uppercase>
                  referência
                </Typography>{' '}
                em suas áreas de atuação.
              </Typography>
            </div>

            <div className="flex flex-col px-4 lg:flex-row space-y-4 lg:space-y-0">
              <div className="flex-none h-16 lg:w-24">
                <Icon icon={filtro} />
              </div>
              <Typography as="div" align="center" className="lg:text-left">
                Conteúdo baseado nas{' '}
                <Typography color="blue-500" weight="black" as="span" uppercase>
                  principais evidências científicas
                </Typography>{' '}
                da atualidade.
              </Typography>
            </div>

            <div className="flex flex-col px-4 lg:flex-row space-y-4 lg:space-y-0">
              <div className="flex-none h-16 lg:w-24">
                <Icon icon={raciocinio} />
              </div>
              <Typography as="div" align="center" className="lg:text-left">
                <Typography color="blue-500" weight="black" as="span" uppercase>
                  coerência, raciocínio clínico
                </Typography>{' '}
                e{' '}
                <Typography color="blue-500" weight="black" as="span" uppercase>
                  individualização
                </Typography>{' '}
                dos atendimentos.
              </Typography>
            </div>

            <div className="flex flex-col px-4 lg:flex-row space-y-4 lg:space-y-0">
              <div className="flex-none h-16 lg:w-24">
                <Icon icon={certificado} />
              </div>
              <Typography as="div" align="center" className="lg:text-left">
                <Typography color="blue-500" weight="black" as="span" uppercase>
                  certificação
                </Typography>{' '}
                para todos os cursos que oferecemos.
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const CardPlatform = () => {
  return (
    <div className="mt-5 space-y-5">
      <div className="relative mx-8 bg-white lg:flex shadow-1 lg:rounded-r-lg">
        <div className="relative w-full h-32 lg:w-56">
          <ImgFilters img={plataformaImage} variant="purple" />
          <div className="absolute flex flex-col items-center w-full lg:items-start -bottom-4 lg:top-6 lg:left-0 lg:w-98">
            <Tag
              className="lg:pl-60 lg:text-right lg:rounded-l-none"
              variant="purple"
            >
              Plataforma Star
            </Tag>
          </div>
        </div>
        <div className="p-4 space-y-5 lg:mt-10 lg:space-y-0">
          <Typography
            weight="black"
            color="blue-500"
            size="lg"
            uppercase
            align="center"
            className="lg:text-left"
          >
            APRENDIZADO & ATENDIMENTO
          </Typography>
          <Typography color="gray-900" uppercase>
            EDUCAÇÃO CONTINUADA E TECNOLOGIA
          </Typography>
        </div>
        <div className="p-4 border-t border-gray-100 lg:border-none lg:w-80 lg:absolute lg:-right-32 lg:h-full lg:flex lg:flex-row lg:items-center">
          <Button
            as="a"
            fullWidth
            className="uppercase"
            href="/recorrencia-courses"
          >
            conheça a plataforma
          </Button>
        </div>
      </div>
    </div>
  )
}

const CardGraduation = () => {
  return (
    <div className="mt-5 space-y-5">
      <div className="relative mx-8 bg-white lg:flex shadow-1 lg:rounded-r-lg">
        <div className="relative w-full h-32 lg:w-56">
          <ImgFilters img={posImage} variant="blue" />
          <div className="absolute flex flex-col items-center w-full lg:items-start -bottom-4 lg:top-6 lg:left-0 lg:w-98">
            <Tag className="lg:pl-60 lg:text-right lg:rounded-l-none">
              Pós-Graduações
            </Tag>
          </div>
        </div>
        <div className="p-4 space-y-5 lg:mt-10 lg:space-y-0">
          <Typography
            weight="black"
            color="blue-500"
            size="lg"
            uppercase
            align="center"
            className="lg:text-left"
          >
            para uma carreira de sucesso
          </Typography>
          <Typography color="gray-900" uppercase>
            ESPECIALIZAÇÕES INOVADORAS & 100% ONLINE
          </Typography>
        </div>
        <div className="p-4 border-t border-gray-100 lg:border-none lg:w-80 lg:absolute lg:-right-32 lg:h-full lg:flex lg:flex-row lg:items-center">
          <Button fullWidth className="uppercase" href="/pos-courses" as="a">
            conheça NOSSAS PÓS
          </Button>
        </div>
      </div>
    </div>
  )
}

const ServicesSection = () => {
  return (
    <div className="bg-blue-500-to-900-y-invert shadow-2">
      <div className="mx-auto max-w-screen-xl">
        <div className="py-5 lg:px-32">
          <Typography color="white" variant="heading-3xl" align="center">
            Cursos & Pós-Graduação
          </Typography>
          <Typography as="div" align="center" className="lg:text-left">
            <Typography color="white" as="span" size="lg">
              Explore o máximo do seu potencial com uma{' '}
              <Typography
                color="white"
                weight="black"
                as="span"
                uppercase
                size="lg"
              >
                PLATAFORMA COMPLETA DE APRENDIZADO{' '}
              </Typography>
              e{' '}
              <Typography
                color="white"
                weight="black"
                as="span"
                uppercase
                size="lg"
              >
                CAPACITAÇÃO{' '}
              </Typography>
              ou{' '}
              <Typography
                color="white"
                weight="black"
                as="span"
                uppercase
                size="lg"
              >
                FAÇA SUA PÓS-GRADUAÇÃO{' '}
              </Typography>
              e fique ainda mais preparado para o mercado de fisioterapia.
            </Typography>
          </Typography>
          <CardPlatform />
          <CardGraduation />
        </div>
      </div>
    </div>
  )
}

const InvistaEmVoceSection = () => {
  return (
    <div className="mx-auto max-w-screen-xl">
      <div className="py-4 lg:grid lg:grid-cols-2">
        <div>
          <img
            src={eadImage}
            className="hidden object-cover w-full h-435 lg:block "
            alt=""
          />
        </div>
        <div>
          <div className="lg:px-8">
            <Typography
              variant="heading-3xl"
              align="center"
              color="blue-500"
              className="mb-4 lg:text-right"
            >
              Invista em Você!
            </Typography>
          </div>
          <div className="px-8">
            <Typography
              color="gray-900"
              size="lg"
              align="center"
              className="lg:text-right"
            >
              Uma das principais habilidades do profissional do século XXI
              parece ser a capacidade de aprender e adquirir novas habilidades
              pelo resto da vida, o que vem sendo chamado de{' '}
              <Typography as="span" color="blue-500" size="lg" weight="bold">
                Life Long Learning.
              </Typography>
            </Typography>
          </div>
          <img
            src={eadImage}
            alt=""
            className="object-cover w-full h-435 lg:hidden"
          />
          <div className="px-8">
            <Typography
              color="gray-900"
              align="center"
              className="leading-loose lg:text-right"
            >
              Assumir que o processo de formação profissional não é algo
              pontual, que a ciência evolui continuamente e traz novas
              descobertas em uma velocidade difícil de acompanhar e que o
              mercado de trabalho vai exigir resultados cada vez mais é algo
              difícil de lidar. É aí que nós entramos!
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

const MaxContainer = ({children}) => {
  return (
    <div className="w-full mx-auto" style={{maxWidth: '1003px'}}>
      {children}
    </div>
  )
}

const ProfessorCard = ({
  name,
  nameShort,
  description,
  descriptionShort,
  photo,
  link,
  slug,
}) => {
  return (
    <Card>
      <Card.Image src={photo} height="h-96 lg:h-60" />
      <Card.Content>
        <Card.Title title={name}>{nameShort || name}</Card.Title>

        <Typography
          color="gray-900"
          className="overflow-hidden truncate whitespace-nowrap"
          title={description}
        >
          {descriptionShort}
        </Typography>
      </Card.Content>
      <Card.Action>
        <Button as="a" fullWidth className="uppercase" href={`/${slug}`}>
          Saiba mais!
        </Button>
      </Card.Action>
    </Card>
  )
}

function shuffle(array) {
  let currentIndex = array.length,
    randomIndex

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--

    // And swap it with the current element.
    ;[array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ]
  }

  return array
}

const Professors = ({className}) => {
  const professors = useProfessorsQuery()
  const [shuffleProfessors, setProfessors] = useState(professors.slice(0, 4))

  const styleRoot = clsx('py-6', className)

  useEffect(() => {
    setProfessors(shuffle(professors).slice(0, 4))
  }, [])

  return (
    <div className={styleRoot}>
      <MaxContainer>
        <div className="my-4 border-t border-gray-100" />
        <Typography
          size="2xl"
          variant="heading-3xl"
          color="blue-500"
          uppercase
          align="center"
          className="lg:text-left lg:text-3xl"
        >
          Professores
        </Typography>

        <div
          className="relative px-6 my-4 grid gap-4 grid-flow-row grid-cols-1 lg:grid-cols-4 lg:px-0"
          style={{zIndex: 2}}
        >
          {shuffleProfessors.slice(0, 4).map(professor => (
            <ProfessorCard key={professor.name} {...professor} />
          ))}
        </div>
        <div className="flex flex-col items-center">
          <Button className="uppercase" as="a" href="/about">
            Conheça todos os professores
          </Button>
        </div>
      </MaxContainer>
    </div>
  )
}

export const IndexPageTemplate = ({heroBanner}) => (
  <div>
    <HeroBanner items={heroBanner} />
    <FisioSection />
    <ServicesSection />
    <InvistaEmVoceSection />
    <Professors />
    <Depositions />
  </div>
)

const IndexPage = ({pageContext}) => {
  return <IndexPageTemplate {...pageContext?.frontmatter} />
}

export default IndexPage
